export default "__VITE_ASSET__202fc45e__"